import React, { useState, useRef, useEffect } from "react";
import { Tabs, Button, message, Typography, Divider } from "antd";
import {
  Page,
  Text,
  View,
  Document,
  StyleSheet,
  Image,
  pdf,
} from "@react-pdf/renderer";
import { PDFDocument } from "pdf-lib";
import TableGroup from "../../exportacion_react_pdf/TableGroup";
import config from "../../../config";
import { ArrowLeftOutlined, DownloadOutlined } from "@ant-design/icons"; // Iconos de Ant Design
import { useMediaQuery } from "react-responsive"; // Necesitarás instalar: npm install react-responsive

const baseUrl = config.baseUrl;
const { Title } = Typography;

// Estilos para el PDF
const styles = StyleSheet.create({
  page: {
    flexDirection: "column",
    paddingTop: 10,
    paddingRight: 60,
    paddingLeft: 60,
    paddingBottom: 100,
    fontFamily: "Times-Roman",
  },
  section: {
    margin: 10,
    padding: 10,
    flexGrow: 1,
  },
  title: {
    fontSize: 12,
    marginTop: 5,
    marginBottom: 20,
    textAlign: "center",
    fontWeight: "bold",
    fontFamily: "Times-Bold",
  },
  title_1: {
    fontSize: 12,
    textAlign: "center",
    fontWeight: "bold",
    marginTop: 5,
    marginBottom: 10,
    backgroundColor: "#BFBFBF", // Color de fondo verde claro
    padding: 5,
  },
  title_respuesta: {
    fontSize: 12,
    marginTop: 7,
    textAlign: "justify",
    marginBottom: 5,
    borderBottomWidth: 1,
    borderBottomColor: "#000",
    textDecoration: "underline",
  },
  textareaLabel: {
    fontSize: 10,
    lineHeight: 1.5,
    textAlign: "justify",
    marginBottom: 12,
    marginTop: 12,
    fontFamily: "Times-Roman",
  },
  header: {
    marginBottom: 20,
  },
  headerTable: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "flex-start",
    width: "100%",
    paddingTop: 10,
    paddingRight: 10,
    paddingLeft: 10,
    marginBottom: 20,
  },
  banner: {
    width: "100%",
    height: 40,
  },
  tableInfo: {
    fontSize: 10,
    fontFamily: "Times-Roman",
    textAlign: "left",
  },
  tableTitle: {
    fontWeight: "bold",
  },
  logoColumn: {
    width: "75%",
    alignItems: "center",
  },
  infoColumn: {
    width: "220px",
    borderWidth: 1,
    borderColor: "#000",
  },
  codeRow: {
    padding: 3,
    borderBottomWidth: 1,
    borderBottomColor: "#000",
  },
  codeText: {
    fontSize: 10,
    fontFamily: "Times-Roman",
    textAlign: "center",
  },
  dateVersionRow: {
    flexDirection: "row",
    height: "25px",
  },
  dateCell: {
    width: "55%",
    borderRightWidth: 1,
    borderRightColor: "#000",
    padding: 3,
    paddingLeft: 8,
    justifyContent: "center",
  },
  versionCell: {
    width: "45%",
    padding: 3,
    paddingLeft: 8,
    justifyContent: "center",
  },
  text: {
    fontSize: 10,
    fontFamily: "Times-Roman",
    textAlign: "left",
  },
  footer: {
    position: "absolute",
    bottom: 20, // Coloca el footer al final de la página
    left: 20,
    right: 20,
    textAlign: "center",
    fontSize: 10,
  },
  logo: {
    justifyContent: "center",
    alignItems: "center",
  },
  date: {
    fontSize: 12,
    textAlign: "left",
    fontWeight: "bold",
  },
  table: {
    width: "100%",
    borderWidth: 1,
    borderColor: "#000",
    borderStyle: "solid",
    marginTop: 10,
  },
  tableRow: {
    flexDirection: "row",
    borderBottomWidth: 1,
  },
  tableHeader: {
    borderStyle: "solid",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
    padding: 5,
    backgroundColor: "#052956", // Fondo azul oscuro
    color: "#FFFFFF", // Letra en blanco
    fontWeight: "bold",
    flex: 1,
  },
  tableCol: {
    width: "33%", // Cada columna ocupa un tercio del ancho
    padding: 5,
    textAlign: "center",
    borderLeftWidth: 1,
    borderRightWidth: 1,
  },
  tableCell: {
    margin: 5,
    fontSize: 10,
  },
  questionSection: {
    marginTop: 7,
  },
  questionText: {
    fontSize: 10,
    fontWeight: "bold",
    marginBottom: 5,
  },
  checkbox: {
    width: 15,
    height: 15,
    borderWidth: 1,
    borderColor: "#000",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    marginRight: 10, // Añadir separación entre la casilla y el texto
  },
  checkboxText: {
    fontSize: 10,
    color: "#000",
  },
  checkboxContainerHorizontal: {
    flexDirection: "row",
    flexWrap: "wrap",
    alignItems: "center",
    marginTop: 7,
  },
  checkboxContainer: {
    flexDirection: "row",
    marginBottom: 10,
  },
  checked: {
    backgroundColor: "#fff",
    justifyContent: "center",
    marginR: 10,
    alignItems: "center",
    borderColor: "#000",
  },
  textarea: {
    fontSize: 10,
    borderWidth: 1,
    borderColor: "#000",
    padding: 10,
    borderRadius: 5,
    width: "100%", // Ajuste automático al ancho disponible
    minHeight: 40, // Asegura que tenga un mínimo de altura
    flexShrink: 1, // Permite que el contenedor ajuste su tamaño según el contenido
    backgroundColor: "#f0f0f0",
  },
  signatureContainer: {
    flexDirection: "row",
    justifyContent: "space-between",
    marginTop: 20,
    marginBottom: 20, // Agregar separación al final de la sección
  },
  signature: {
    width: 150,
    height: 100,
    maxHeight: 100,
    textAlign: "center",
  },
  interlineText: {
    marginTop: 5,
    fontSize: 10,
    textAlign: "center",
  },
  footerSpacer: {
    flexGrow: 1, // Esto empuja el contenido hacia arriba
  },
  column: {
    width: "33%", // Cada columna ocupa un tercio del ancho
    alignItems: "center", // Centra los elementos dentro de las columnas
  },
  tableCol30: {
    width: "60%",
    padding: 5,
    borderRightWidth: 1,
    borderRightColor: "#000",
    fontSize: 10,
  },
  tableCol70: {
    width: "40%",
    padding: 5,
    textAlign: "left",
    borderRightWidth: 1,
    borderRightColor: "#000",
    fontSize: 10,
  },
  tableCol33: {
    width: "33.3%",
    padding: 5,
    textAlign: "left",
    borderRightWidth: 1,
    borderRightColor: "#000",
    fontSize: 10,
  },

  sectionTitle: {
    fontSize: 10,
    fontFamily: "Times-Bold",
    marginTop: 15,
    marginBottom: 10,
    textAlign: "center",
  },
  normalText: {
    fontSize: 10,
  },
  sectionExclusive: {
    marginTop: 20,
    marginBottom: 10,
    padding: 10,
    borderWidth: 1,
    borderColor: "#000",
  },
  paragraph: {
    fontSize: 10,
    textAlign: "justify",
    marginBottom: 8,
    lineHeight: 1.5,
  },
  blueText: {
    color: "#0000FF",
    textDecoration: "underline",
  },
  signatureSection: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: 10,
  },
  signatureTitle: {
    fontWeight: "bold",
    marginRight: 10,
  },
  tableColHeader: {
    borderStyle: "solid",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
    padding: 5,
    backgroundColor: "#052956", // Fondo azul oscuro
    color: "#FFFFFF", // Letra en blanco
    fontWeight: "bold",
    flex: 1,
    textAlign: "center",
  },
  subtitleRow: {
    backgroundColor: "#f2f2f2",
    borderTopWidth: 1,
    borderBottomWidth: 1,
    borderColor: "#000",
  },
  subtitleText: {
    fontSize: 10,
    fontWeight: "bold",
    textAlign: "center",
  },
  signatureBlock: {
    marginTop: 20,
    marginBottom: 20,
    width: "100%",
  },
  signatureHeader: {
    fontSize: 10,
    fontWeight: "bold",
    marginBottom: 10,
    fontFamily: "Times-Bold",
  },
  signatureContent: {
    marginLeft: 20,
    marginTop: 5,
  },
  signatureLine: {
    borderBottomWidth: 1,
    borderBottomColor: "#000",
    width: "60%",
    marginBottom: 5,
  },
  signatureLabel: {
    fontSize: 10,
    marginTop: 5,
    marginBottom: 5,
  },
  signatureText: {
    fontSize: 10,
    marginBottom: 3,
  },
  signatureNote: {
    fontSize: 10,
    fontStyle: "italic",
    marginTop: 5,
    color: "#666",
    marginLeft: 20,
  },
  imageContainer: {
    flexDirection: "row",
    flexWrap: "wrap",
    justifyContent: "space-around",
  },
imageRow: {
  flexDirection: "row",
  justifyContent: "space-between",
  width: "100%",
},

image: {
  width: "48%",
  height: 260,
  objectFit: "cover",
  marginTop: 5,
},
  boldText: {
    fontWeight: "bold",
    fontFamily: "Times-Bold",
    textAlign: "center",
  },
  // ...tus estilos existentes
  footerCodeContainer: {
    position: "absolute",
    bottom: 30,
    right: 40,
  },
  footerCode: {
    fontSize: 10,
    fontStyle: "italic",
    color: "#0D0D0D",
    fontFamily: "Helvetica-Bold", // <-- Esta línea hace el texto en negrita
  },
});

const chunkArray = (array, chunkSize) => {
  const chunks = [];
  for (let i = 0; i < array.length; i += chunkSize) {
    chunks.push(array.slice(i, i + chunkSize));
  }
  return chunks;
};

// Componente para secciones de fotografías con salto de página correcto.
//
// Problema original: el View wrap={false} externo englobaba el título + TODAS
// las filas de imágenes. Cuando había 2+ filas, el bloque era demasiado alto
// para encontrar espacio libre y react-pdf lo recortaba igual sobre el footer.
//
// Solución: título + primera fila van en un wrap={false}; cada fila adicional
// también en su propio wrap={false}. Si una fila no cabe respetando el
// paddingBottom (margen de pie de página obligatorio), se mueve completa
// a la página siguiente sin quedar recortada.
const PhotoSection = ({ title, photos, baseUrl }) => {
  if (!photos || photos.length === 0) {
    return (
      <View wrap={false}>
        <Text style={styles.title}>{title}</Text>
        <Text style={styles.normalText}>No hay fotografías</Text>
      </View>
    );
  }

  const rows = chunkArray(photos, 2);

  return (
    <View>
      {rows.map((chunk, rowIndex) => (
        <View key={rowIndex} wrap={false}>
          {rowIndex === 0 && (
            <Text style={styles.title}>{title}</Text>
          )}
          <View style={styles.imageRow}>
            {chunk.map((foto, index) => (
              <Image
                key={index}
                style={styles.image}
                source={{ uri: `${baseUrl}${foto}` }}
              />
            ))}
          </View>
        </View>
      ))}
    </View>
  );
};

// ====== Documento React-PDF con data simulada ======
const MyPDF = ({ formData }) => {
  if (!formData) {
    return (
      <Document>
        <Page style={styles.page}>
          <Text>No hay datos disponibles</Text>
        </Page>
      </Document>
    );
  }

  return (
    <Document>
      <Page style={styles.page}>
        {/* Header Fijo */}
        <View fixed>
          <View style={styles.headerTable}>
            <View style={styles.logoColumn}>
              <Image style={styles.banner} src={"Banner_membrete.png"} />
            </View>
            <View style={styles.infoColumn}>
              <View style={styles.codeRow}>
                <Text style={styles.codeText}>CÓDIGO: IR-F-113</Text>
              </View>
              <View style={styles.dateVersionRow}>
                <View style={styles.dateCell}>
                  <Text style={styles.text}>FECHA: 2020-07-14</Text>
                </View>
                <View style={styles.versionCell}>
                  <Text style={styles.text}>VERSIÓN: V-1</Text>
                </View>
              </View>
            </View>
          </View>
        </View>

        {/* Título */}
        <Text style={styles.title}>
          ACTA DE VISITA IMPLEMENTACIÓN COMPONENTE FORMACIÓN Y ACOMPAÑAMIENTO
          ESTRATEGIA DE SOSTENIBILIDAD
        </Text>

        {/* Tabla Factores */}
        <TableGroup
          headers={["factor", "actividad", "subActividad"]}
          headerDescriptions={[
            "FACTOR DE SOSTENIBILIDAD",
            "ACTIVIDAD DERIVADA",
            "SUBACTIVIDAD",
          ]}
          data={formData.lista_factores}
        />

        {/* Información General - Aplicando wrap para no cortar en páginas */}
        <View style={styles.table} wrap>
          <View style={styles.tableRow}>
            <View style={styles.tableColHeader}>
              <Text style={styles.tableCell}>INFORMACIÓN GENERAL</Text>
            </View>
          </View>

          {[
            { label: "VISITA N°", value: formData?.numero_visita },
            { label: "FECHA VISITA", value: formData?.fecha_registro },
            { label: "GRUPO TERRITORIAL", value: formData?.grupoTerritorial },
            { label: "DEPARTAMENTO", value: formData?.departamento },
            { label: "MUNICIPIO", value: formData?.municipio },
            { label: "VEREDA / CORREGIMIENTO", value: formData?.vereda },
            { label: "CODIGO PRE PP", value: formData?.codigoPREPP },
            {
              label: "NOMBRE DEL PROYECTO PRODUCTIVO",
              value: formData?.nombreProyecto,
            },
            {
              label: "NOMBRE DE LA FORMA ASOCIATIVA",
              value: formData?.nombreFormaAsociativa,
            },
            { label: "HORA INICIO", value: formData?.horaInicio },
            { label: "HORA FINALIZACIÓN", value: formData?.horaFin },
            {
              label: "NUMERO DE PERSONAS",
              value:
                Number(formData?.numeroHombres || 0) +
                Number(formData?.numeroMujeres || 0),
            },
            { label: "No. DE HOMBRES", value: formData?.numeroHombres },
            { label: "No. DE MUJERES", value: formData?.numeroMujeres },
            { label: "LATITUD", value: formData?.latuser },
            { label: "LONGITUD", value: formData?.lnguser },
            {
              label: "LINEA PRODUCTIVA DEL PROYECTO",
              value: formData?.linea_productiva,
            },
          ].map((item, index) => (
            <View key={index} style={styles.tableRow}>
              <Text style={styles.tableCol70}>{item.label}</Text>
              <Text style={styles.tableCol30}>{item.value || ""}</Text>
            </View>
          ))}
        </View>

        {/* Aspectos Metodológicos */}
        <View style={styles.table} wrap>
          {" "}
          {/* wrap permite que la tabla pase a otra página */}
          <View style={styles.tableRow} break>
            {" "}
            {/* break permite que esta sección pase a otra página si es necesario */}
            <View style={styles.tableColHeader}>
              <Text style={styles.tableCell}>ASPECTOS METODOLÓGICOS</Text>
            </View>
          </View>
          <View style={styles.tableRow}>
            <Text style={styles.tableCol70}>TIPO DE ACTIVIDAD</Text>
            <Text style={styles.tableCol30}>
              {formData?.tipoActividad || ""}
            </Text>
          </View>
          <View style={styles.tableRow}>
            <Text style={styles.tableCol70}>MODALIDAD DE SESIÓN</Text>
            <Text style={styles.tableCol30}>
              {formData?.modalidad_sesion_capacitacion || ""}
            </Text>
          </View>
        </View>

        {/* Título de la descripción del proyecto */}
        <Text style={styles.title}>ACTIVIDADES DESARROLLADAS EN LA VISITA</Text>

        {/* Fila de la tabla para la descripción del proyecto */}
        <View style={styles.infoContainer}>
          <Text style={styles.textareaLabel}>
            {formData?.actividadesDesarrolladas || ""}
          </Text>
        </View>

        <View style={styles.table} wrap>
          <View style={styles.tableRow}>
            <View style={styles.tableColHeader}>
              <Text style={styles.tableCell}>
                AVANCE DE ACTIVIDADES POR FACTORES DE SOSTENIBILIDAD
              </Text>
            </View>
          </View>

          <View style={styles.tableRow}>
            <Text style={styles.tableCol70}>
              Avance de actividades Factor 1. Acompañamiento y fortalecimiento
              técnico y financiero
            </Text>
            <Text style={styles.tableCol30}>
              {formData?.avanceFactor1 || ""}
            </Text>
          </View>

          <View style={styles.tableRow}>
            <Text style={styles.tableCol70}>
              Avance de actividades Factor 2. Fortalecimiento organizativo y
              asociativo
            </Text>
            <Text style={styles.tableCol30}>
              {formData?.avanceFactor2 || ""}
            </Text>
          </View>

          <View style={styles.tableRow}>
            <Text style={styles.tableCol70}>
              Avance de Actividades: Factor 3. Acompañamiento y fortalecimiento
              a procesos de mercadeo y comercialización
            </Text>
            <Text style={styles.tableCol30}>
              {formData?.avanceFactor3 || ""}
            </Text>
          </View>

          <View style={styles.tableRow}>
            <Text style={styles.tableCol70}>
              Avance de actividades Factor 4. Acompañamiento y gestión para la
              articulación e incidencia territorial
            </Text>
            <Text style={styles.tableCol30}>
              {formData?.avanceFactor4 || ""}
            </Text>
          </View>

          <View style={styles.tableRow}>
            <Text style={styles.tableCol70}>
              Avance de actividades Factor 5. Acompañamiento para la
              Implementación de los enfoques diferenciales
            </Text>
            <Text style={styles.tableCol30}>
              {formData?.avanceFactor5 || ""}
            </Text>
          </View>

          <View style={styles.tableRow}>
            <Text style={styles.tableCol70}>
              Avance de actividades Factor 6. Generación de condiciones para el
              acceso a tierra:
            </Text>
            <Text style={styles.tableCol30}>
              {formData?.avanceFactor6 || ""}
            </Text>
          </View>

          <View style={styles.tableRow}>
            <Text style={styles.tableCol70}>
              Avance de actividades Factor 7. Promoción de la articulación
              interinstitucional para la seguridad humana en los territorios:
            </Text>
            <Text style={styles.tableCol30}>
              {formData?.avanceFactor7 || ""}
            </Text>
          </View>

          <View style={styles.tableRow}>
            <Text style={styles.tableCol70}>
              Avance de actividades Factor 8. Acompañamiento para la
              implementación de los planes/programas de manejo ambiental (PMA) y
              el fortalecimiento de relaciones sostenibles entre seres humanos y
              otras formas de vida:
            </Text>
            <Text style={styles.tableCol30}>
              {formData?.avanceFactor8 || ""}
            </Text>
          </View>

          <View style={styles.tableRow}>
            <Text style={styles.tableCol70}>Próxima Sesión</Text>
            <Text style={styles.tableCol30}>
              {formData?.proximaSesion || ""}
            </Text>
          </View>
        </View>

        <Text style={styles.title}>HALLAZGOS</Text>

        <View style={styles.infoContainer}>
          <Text style={styles.textareaLabel}>{formData?.hallazgos || ""}</Text>
        </View>

        <Text style={styles.title}>ACUERDOS</Text>

        <TableGroup
          headers={["compromiso", "responsable", "fechaLimite"]}
          headerDescriptions={["COMPROMISO", "RESPONSABLE", "FECHA LIMITE"]}
          data={formData.acuerdos}
        />

        <Text style={styles.title}>LISTA DE PARTICIPANTES</Text>

        <TableGroup
          headers={["codigo_sirr", "nombre_completo"]}
          headerDescriptions={["CODIGO SIRR", "NOMBRE COMPLETO"]}
          data={formData.participantes}
        />

        <View style={styles.signatureBlock}>
          <Text style={styles.signatureHeader}>
            FIRMA PROFESIONAL ASISTENTE TÉCNICO
          </Text>
          <View style={styles.signatureContent}>
            {formData?.firmaProfesionalAsistenteTecnico ? (
              <Image
                style={styles.signature}
                src={baseUrl + formData.firmaProfesionalAsistenteTecnico}
                alt="Firma del asistente técnico"
              />
            ) : (
              <Text style={styles.signatureText}>Firma no disponible</Text>
            )}

            <View style={styles.signatureLine} />
            <Text style={styles.signatureText}>
              NOMBRE: {formData?.nombreProfesionalAsistenteTecnico || ""}
            </Text>
            <Text style={styles.signatureText}>
              CC: {formData?.ccProfesionalAsistenteTecnico || ""}
            </Text>
            <Text style={styles.signatureText}>
              PROFESIÓN: {formData?.ProfesionProfesionalAsistenteTecnico || ""}
            </Text>
          </View>
        </View>

        <View style={styles.signatureBlock}>
          <Text style={styles.signatureHeader}>
            FIRMA PROFESIONAL ASISTENTE TÉCNICO 2
          </Text>
          <View style={styles.signatureContent}>
            {formData?.firmaProfesionalAsistenteTecnico_2 ? (
              <Image
                style={styles.signature}
                src={baseUrl + formData.firmaProfesionalAsistenteTecnico_2}
                alt="Firma del asistente técnico 2"
              />
            ) : (
              <Text style={styles.signatureText}>Firma no disponible</Text>
            )}

            <View style={styles.signatureLine} />
            <Text style={styles.signatureText}>
              NOMBRE: {formData?.nombreProfesionalAsistenteTecnico_2 || ""}
            </Text>
            <Text style={styles.signatureText}>
              CC: {formData?.ccProfesionalAsistenteTecnico_2 || ""}
            </Text>
            <Text style={styles.signatureText}>
              PROFESIÓN:{" "}
              {formData?.ProfesionProfesionalAsistenteTecnico_2 || ""}
            </Text>
          </View>
        </View>

        <Text style={styles.title}>FIRMA PARTICIPANTES</Text>

        {formData.participantes && formData.participantes.length > 0 ? (
          formData.participantes.map((participante, index) => (
            <View key={index} style={styles.signatureBlock}>
              <Text style={styles.signatureHeader}>
                FIRMA PARTICIPANTE {participante.id}
              </Text>
              <View style={styles.signatureContent}>
                {formData?.[`firmaParticipante_${participante.id}`] ? (
                  <Image
                    style={styles.signature}
                    src={
                      baseUrl + formData[`firmaParticipante_${participante.id}`]
                    }
                  />
                ) : (
                  <Text style={styles.signatureText}>Firma no disponible</Text>
                )}

                <View style={styles.signatureLine} />
                <Text style={styles.signatureText}>
                  NOMBRE: {participante.nombre_completo || ""}
                </Text>
                <Text style={styles.signatureText}>
                  CÓDIGO SIRR: {participante.codigo_sirr || ""}
                </Text>
              </View>
            </View>
          ))
        ) : (
          <Text>No hay participantes</Text>
        )}


        <View wrap={false}>
          <Text style={styles.title}>ANEXOS</Text>
        </View>
        <PhotoSection
          title="FOTOGRAFÍA CON LOS PARTICIPANTES"
          photos={formData.fotografia_participantes}
          baseUrl={baseUrl}
        />

        <PhotoSection
          title="FOTOGRAFÍA (BUENA DEFINICIÓN) EN EL LUGAR DONDE SE DESARROLLA EL PROYECTO PRODUCTIVO"
          photos={formData.fotografias_lugar}
          baseUrl={baseUrl}
        />

        <PhotoSection
          title="FOTOGRAFÍA (BUENA DEFINICIÓN), QUE REPRESENTE LA FINALIDAD DEL PROYECTO PRODUCTIVO"
          photos={formData.fotografia_finalidad}
          baseUrl={baseUrl}
        />

        <PhotoSection
          title="FOTOGRAFÍA (BUENA DEFINICIÓN) CON EL USUARIO DILIGENCIANDO EL ACTA DE LA VISITA"
          photos={formData.fotografia_acta}
          baseUrl={baseUrl}
        />

        <PhotoSection
          title="FOTOGRAFÍA (BUENA DEFINICIÓN) DONDE SE EVIDENCIE UNA ACTIVIDAD PROPIA DEL PROYECTO PRODUCTIVO"
          photos={formData.fotografia_actividad}
          baseUrl={baseUrl}
        />

        <View style={styles.footerCodeContainer}>
          <Text style={styles.footerCode}>
            Código Único: {formData?.codigo_pdf || "N/A"}
          </Text>{" "}
        </View>
      </Page>
    </Document>
  );
};

const PdfVisitaTecnicaSostenibilidad = ({
  formData: initialFormData,
  onClose,
}) => {
  const [data, setData] = useState(initialFormData || {});
  const [activeTab, setActiveTab] = useState("1");
  const [reactPdfPreview, setReactPdfPreview] = useState(null);
  const [previewUrl, setPreviewUrl] = useState(null);
  const mergedPdfRef = useRef(null);
  const reactPdfRef = useRef(null);
  const isDesktop = useMediaQuery({ minWidth: 768 });

  // Función para generar preview de React-PDF
  const generateReactPreview = async () => {
    const blob = await pdf(<MyPDF formData={data} />).toBlob();
    reactPdfRef.current = blob; // guardamos el blob para poder descargarlo
    setReactPdfPreview(URL.createObjectURL(blob));
  };

  // Función para generar PDF unificado
  const mergePdfs = async () => {
    try {
      // 👉 Generar URL con timestamp para evitar caché
      const pdfUrl = `${baseUrl}${data.anexoFirmas}?t=${new Date().getTime()}`;
      const reactPdfBlob = await pdf(<MyPDF formData={data} />).toBlob();
      const pdf1 = await PDFDocument.load(await reactPdfBlob.arrayBuffer());
      const pdf2 = await PDFDocument.load(
        await fetch(pdfUrl).then((res) => res.arrayBuffer())
      );

      const mergedPdf = await PDFDocument.create();
      (await mergedPdf.copyPages(pdf1, pdf1.getPageIndices())).forEach((p) =>
        mergedPdf.addPage(p)
      );
      (await mergedPdf.copyPages(pdf2, pdf2.getPageIndices())).forEach((p) =>
        mergedPdf.addPage(p)
      );

      const mergedBytes = await mergedPdf.save();
      const blob = new Blob([mergedBytes], { type: "application/pdf" });
      mergedPdfRef.current = blob;
      setPreviewUrl(URL.createObjectURL(blob));

      message.success("PDF unificado generado ✅");
    } catch (error) {
      console.error(error);
      message.error("Error generando PDF unificado ❌");
    }
  };

  // 👉 Función utilitaria para construir el nombre de archivo
  const buildFileName = ({
    modalidadSecion = "Visita técnica",
    fecha_registro,
    numero_visita = "1",
    unificado = false,
  }) => {
    // Diccionario de equivalencias exactas
    const equivalencias = {
      "Visita técnica": "Visita",
      "Gira técnica": "Gira",
      "Centros demostrativos de demostración": "Centro_Demostrativo",
      ECA: "Eca",
      Taller: "Taller",
      "Dia de campo": "Dia_Campo",
      Otro: "Otro",
    };

    // Usar equivalencia directa o fallback a modalidad limpia
    let nombre =
      equivalencias[modalidadSecion] || modalidadSecion.replace(/\s+/g, "_");

    // Formatear fecha: 2025-09-04 → 2025_09_04
    let fecha = fecha_registro || new Date().toISOString().split("T")[0];
    fecha = fecha.replace(/-/g, "_");

    // Construir nombre final
    return `1_${nombre}_${numero_visita}_${fecha}${
      unificado ? "_unificado" : ""
    }.pdf`;
  };

  // 👉 Función para descargar PDF React
  const downloadReactPdf = () => {
    if (!reactPdfRef.current) {
      return message.warning("No hay PDF disponible");
    }
    const url = URL.createObjectURL(reactPdfRef.current);
    const link = document.createElement("a");
    link.href = url;

    link.download = buildFileName({
      modalidadSecion: data?.modalidad_sesion_capacitacion,
      fecha_registro: data?.fecha_registro,
      numero_visita: data?.numero_visita,
      unificado: false,
    });

    link.click();
  };

  // 👉 Función para descargar PDF unificado
  const downloadMerged = () => {
    if (!mergedPdfRef.current) {
      return message.warning("No hay PDF unificado disponible");
    }
    const url = URL.createObjectURL(mergedPdfRef.current);
    const link = document.createElement("a");
    link.href = url;

    link.download = buildFileName({
      modalidadSecion: data?.modalidad_sesion_capacitacion,
      fecha_registro: data?.fecha_registro,
      numero_visita: data?.numero_visita,
      unificado: false,
    });

    link.click();
  };

  // ==== useEffect para inicializar el tab y generar preview automáticamente ====
  useEffect(() => {
    if (!data) return;

    if (data.modoFirma === "firma_participantes" || !data.modoFirma) {
      setActiveTab("react");
      generateReactPreview();
    } else if (data.modoFirma === "anexo_firma_participantes") {
      setActiveTab("unificado");
      mergePdfs();
    }
  }, [data]);

  if (!data) return <div>Cargando...</div>;

  const tabs = [];

  if (data.modoFirma === "firma_participantes" || !data.modoFirma) {
    // PDF React
    tabs.push({
      key: "react",
      label: "",
      children: (
        <div style={{ padding: 20 }}>
          <div className="flex flex-col md:flex-row gap-4 mb-4">
            <Button
              type="danger"
              size={isDesktop ? "large" : "middle"}
              icon={<ArrowLeftOutlined />}
              onClick={onClose}
            >
              Volver
            </Button>
            <Button
              type="primary"
              size={isDesktop ? "large" : "middle"}
              icon={<DownloadOutlined />}
              onClick={downloadReactPdf}
            >
              Descargar PDF
            </Button>
          </div>
          {reactPdfPreview && (
            <iframe
              src={reactPdfPreview}
              style={{ width: "100%", height: "600px", border: "none" }}
              title="React PDF Preview"
            />
          )}
        </div>
      ),
    });
  } else if (data.modoFirma === "anexo_firma_participantes") {
    // PDF unificado
    tabs.push({
      key: "unificado",
      label: "",
      children: (
        <div style={{ padding: 20 }}>
          <div className="flex flex-col md:flex-row gap-4 mb-4">
            <Button
              type="danger"
              size={isDesktop ? "large" : "middle"}
              icon={<ArrowLeftOutlined />}
              onClick={onClose}
            >
              Volver
            </Button>
            <Button
              type="primary"
              size={isDesktop ? "large" : "middle"}
              icon={<DownloadOutlined />}
              onClick={downloadMerged}
            >
              Descargar PDF
            </Button>
          </div>
          {previewUrl && (
            <div style={{ marginTop: 20 }}>
              <iframe
                src={previewUrl}
                style={{ width: "100%", height: "600px", border: "none" }}
                title="Merged PDF Preview"
              />
            </div>
          )}
        </div>
      ),
    });
  }

  return (
    <div className="min-h-screen bg-gray-100 p-4 md:p-8">
      <div className="max-w-6xl mx-auto">
        <div className="bg-white rounded-lg shadow-lg p-4 md:p-6 mb-8">
          {/* Título y botones */}
          <div style={{ textAlign: "center", marginBottom: "20px" }}>
            <Title
              level={isDesktop ? 2 : 3}
              style={{ color: "#1890ff", fontWeight: "bold" }}
            >
              Reporte de visita técnica de sostenibilidad
            </Title>
            <Divider />
          </div>
          <Tabs activeKey={activeTab} onChange={setActiveTab} items={tabs} />
        </div>
      </div>
    </div>
  );
};

export default PdfVisitaTecnicaSostenibilidad;